<script setup>
const props = defineProps({
    companyName: String,
    companyId: Number,
    dislikeId: Number,
    displayed: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: Boolean,
        default: true,
    },
    link: String,
    linkText: String,
    linkEvent: String,
    onActionClick: Function,
    text: {
        type: String,
        default: 'Gespeichert!',
    },
    value: Number,
});

function onLinkClick(event) {
    if (props.onActionClick) {
        event.preventDefault();
        props.onActionClick();
    }
}
</script>

<template>
    <Transition name="m-appSnackbar-fade">
        <div
            v-if="displayed"
            class="m-appSnackbar k-c-snackbar"
            :class="{
                'm-appSnackbar--5000': props.displayed,
            }"
        >
            <div
                class="k-c-snackbar__content"
                :class="{
                    'k-c-snackbar__content--link': props.link,
                }"
            >
                <template v-if="icon">
                    <svg
                        fill="currentColor"
                        class="k-c-snackbar__icon m-appSnackbar__icon"
                        viewBox="0 0 16 18"
                    >
                        <path
                            d="M5.76,14.01c-0.17,0-0.34-0.07-0.46-0.2L1.24,9.67C0.98,
                            9.42,0.99,9,1.25,8.75C1.5,8.5,1.91,8.51,2.16,8.76l3.59,3.67 l8.08-8.25c0.25-0.26,
                            0.66-0.26,0.92-0.01c0.26,0.25,0.26,0.66,0.01,0.92l-8.54,8.72C6.1,13.94,5.93,
                            14.01,5.76,14.01z"
                        />
                    </svg>
                </template>
                <span class="m-appSnackbar__infoText">{{ text }}</span>
                <template v-if="link">
                    <a
                        :href="link"
                        class="m-appSnackbar__link"
                        :class="{
                            'm-appSnackbar__link--action': props.onActionClick,
                        }"
                        :data-event="linkEvent"
                        @click="onLinkClick"
                    >{{ linkText }}</a>
                </template>
            </div>
        </div>
    </Transition>
</template>

<style lang="scss">
@import 'util/mediaQueries';
@import 'util/design-system/link';
@import '~@karriereat/global-styles/scss/components/snackbar/index';

$snackbar-size-tablet: 460px;
$snackbar-icon-visual-spacing: 1px;
$animation-duration-medium: 5000ms;

.m-appSnackbar {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    pointer-events: auto;

    @include tablet {
        width: $snackbar-size-tablet;
        max-width: none;
    }

    &-fade-enter-active,
    &-fade-leave-active {
        transition: opacity $animation-duration-medium;
    }

    &-fade-enter-from,
    &-fade-leave-to {
        opacity: 0;
    }

    &-fade-enter-to,
    &-fade-leave-from {
        opacity: 1;
    }

    &__icon {
        align-self: flex-start;
        margin-top: $snackbar-icon-visual-spacing;
    }

    &__link {
        @include link-underline-white;
        padding-left: $k-spacing--xs;
        white-space: nowrap;
    }

    &__infoText {
        text-align: left;
    }

    &--5000 {
        @include k-c-snackbar-toggle($animation-duration-medium);
    }
}
</style>
